export default __webpack_public_path__ + "static/media/addon-landing-thumbnail.c128f72a.jpg";